import React from "react";

export function Plus( props: React.SVGProps<SVGSVGElement> ) {
    return (
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" {...props}>
            <path d="M3 5H15V7H3V5Z" fill="currentColor" />
            <path d="M8 12L8 0L10 -8.74228e-08L10 12L8 12Z" fill="currentColor" />
        </svg>
    );
}
